import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Modal, Space, Table, Tooltip, message } from "antd";
import axios from "axios";
import { PRIMARY_RED } from "constants/colors";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";
import { setBreadcrumbItems } from "../../store/actions";

const AddressListing = (props) => {
  const [address, setAddress] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const token = authUser?.token;
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const breadcrumbItems = [
    { title: "Address", link: "#" },
    { title: "Address Listing", link: "#" },
  ];

  useEffect(() => {
    props.setBreadcrumbItems("Address", breadcrumbItems);
    fetchAddress();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchText]);

  const fetchAddress = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASEURL}/address`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAddress(response.data);
    } catch (err) {
      message.error("Failed to load addresses");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (addressId, addressDetails) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_BASEURL}/address/${addressId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      message.success(`Deleted address: ${addressDetails}`);
      fetchAddress();
    } catch (err) {
      message.error("Failed to delete address");
    }
  };

  const filteredAddresses = address.filter((addr) => {
    const search = searchText.toLowerCase();
    return (
      (addr.addressDetails || "").toLowerCase().includes(search) ||
      (addr.city || "").toLowerCase().includes(search) ||
      (addr.state || "").toLowerCase().includes(search)
    );
  });

  const paginatedData = filteredAddresses.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const columns = [
    { title: "Address Details", dataIndex: "addressDetails", key: "addressDetails" },
    { title: "City", dataIndex: "city", key: "city" },
    { title: "State", dataIndex: "state", key: "state" },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <Space>
          <Tooltip title="Edit">
            <Button
              type="text"
              icon={<EditOutlined />}
              onClick={() => navigate(`/edit-address/${record._id}`)}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              type="text"
              icon={<DeleteOutlined />}
              style={{ color: PRIMARY_RED }}
              onClick={() => {
                setSelectedAddress(record);
                setIsModalVisible(true);
              }}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <React.Fragment>
      <Row>
        <Col xs="12">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <input
              type="text"
              placeholder="Search address..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250, padding: "6px 10px" }}
            />
            <Button
              type="primary"
              icon={<PlusOutlined />}
              style={{ backgroundColor: PRIMARY_RED }}
              onClick={() => navigate("/add-address")}
            >
              Add Address
            </Button>
          </div>

          <Card>
            <Modal
              title="Delete Address"
              visible={isModalVisible}
              onCancel={() => setIsModalVisible(false)}
              footer={[
                <Button key="cancel" onClick={() => setIsModalVisible(false)} style={{ backgroundColor: "#6c757d", color: "white" }}>
                  Close
                </Button>,
                <Button
                  key="delete"
                  type="primary"
                  style={{ backgroundColor: PRIMARY_RED }}
                  icon={<DeleteOutlined />}
                  onClick={() => {
                    handleDelete(selectedAddress._id, selectedAddress.addressDetails);
                    setIsModalVisible(false);
                  }}
                >
                  Delete
                </Button>,
              ]}
            >
              <p>
                Are you sure you want to delete <strong>{selectedAddress?.addressDetails}</strong> address?
              </p>
            </Modal>

            <CardBody>
              <Table
                columns={columns}
                dataSource={paginatedData}
                rowKey="_id"
                loading={loading}
                pagination={{
                  current: currentPage,
                  pageSize: pageSize,
                  total: filteredAddresses.length,
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "20", "50"],
                }}
                onChange={handleTableChange}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(AddressListing);
